import constants from './constants';

export const toggleNavigation = () => {
  return {
    type: constants.TOGGLE_NAVIGATION,
  };
};
